import {Button} from "./Button";
import React, {useEffect, useState} from "react";

export function EnterSkuModal({open, onSubmit, onClose}) {
    const [sku, setSku] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        if (!open) {
            setSku("");
            setError("");
        }
    }, [open]);

    const handleSubmit = () => {
        if (!sku.trim()) {
            setError("SKU is required");
            return;
        }
        onSubmit(sku.trim());
    };

    if (!open) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex justify-center items-center p-4">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-lg p-6 space-y-4">
                <h2 className="text-xl font-bold">Enter Prodigi SKU</h2>
                <input
                    type="text"
                    className="border p-2 w-full"
                    placeholder="SKU"
                    value={sku}
                    onChange={(e) => {
                        setSku(e.target.value);
                        setError("");
                    }}
                />
                {error && <div className="text-red-600">{error}</div>}
                <div className="flex justify-end gap-4 pt-4">
                    <Button variant="outline" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button onClick={handleSubmit}>
                        Continue
                    </Button>
                </div>
            </div>
        </div>
    );
}